import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ContactService } from '../contact.service';
import { ContractorService } from '../../contractors/contractor.service';
import { PositionService } from '../../positions/position.service';
import { GlobalDataService } from '../../../../services/global-data.service';

export interface Pagination {
  current_page?: number;
  first_item?: number;
  first_page_url?: string;
  last_item?: number;
  last_page?: number;
  last_page_url?: string;
  next_page_url?: string;
  per_page?: number;
  prev_page_url?: string;
  total?: number;
}


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
  providers: [
    ContactService,
    ContractorService,
    PositionService],
  encapsulation: ViewEncapsulation.None
})
export class ContactComponent implements OnInit {

  contacts: string[]= [];	
  loading: boolean = false;
  activePage:number=0;
  pagination: Pagination;
  searchFilter: any = [];
  searchColumn: any = [];
  positionList: any = [];
  contractorList: any = [];


  constructor(
              private router: Router,
              private global: GlobalDataService,
              private contactService: ContactService,    
              private contractorService: ContractorService,    
              private positionService: PositionService    
              ) { }

  ngOnInit() {
      this.fillSearchColumn();
      this.pagination = {current_page: 1,per_page: 1,last_page: 1};

      if(this.global.type=="contact"){
        this.searchFilter= this.global.filter || this.searchFilter;
        this.pagination = this.global.page ||  this.pagination;
      }

      this.loadContacts(this.searchFilter,this.pagination.current_page);
      this.init();
   }

   loadContacts(filter: any[], page:number=1){
   
    this.loading= true;
    this.contactService.getContactByFilter(filter,page).subscribe(response=>{
      this.contacts = response['data'];
      
    
      this.pagination = response['pagination'] || {current_page: 1,per_page: 1,last_page: 1};
      this.activePage=this.pagination.first_item || 1;
     
      this.global.filter=filter;
      this.global.page=this.pagination;
      this.global.type="contact";
      this.loading= false;
    });
   }

   onPaginate(event) {
    event.page = event.page + 1
    this.pagination.current_page= event.page;
    this.loadContacts(this.searchFilter,event.page);
  }
  
  fillSearchColumn() {
    this.searchColumn=[];
    this.searchColumn.push({ label: "Название", value: { column: "full_name", type: "textbox" } });
    this.searchColumn.push({ label: "Должность", value: { column: "position_id", type: "dropdown" , value:  this.positionList} });
    this.searchColumn.push({ label: "Компания", value: { column: "contractor_id", type: "dropdown",value: this.contractorList } });
    this.searchColumn.push({ label: "Склад", value: { column: "store_id", type: "dropdown",value: this.global.user.stores.map(value => {
      return { label: value.name, value: { value: value.id, label: value.name } };
    }) } });
    this.searchColumn.push({ label: "Доступность", value: { column: "active", type: "dropdown",value: [{label: "Активный", value: {value: '1', label: "Активный"}},{label: "Неактивный",value: {value: '0', label: "Неактивный"}}] }});
  }
  setFilter(data){
    this.searchFilter=data;
    this.loading = true;
    this.loadContacts(this.searchFilter,1);
  }



  init(){
    this.positionService.getPosition(1).subscribe(response => {
      this.positionList = response['data'].map(value => {
        return { label: value.name, value: { value: value.id, label: value.name } };
      })
      this.fillSearchColumn();
    });
    this.contractorService.getContractorList().subscribe(response => {
      this.contractorList = response['data'].map(value => {
        return { label: value.name, value: { value: value.id, label: value.name } };
      })
      this.fillSearchColumn();
    })

  }

  add():void{
  	this.router.navigate(['dashboard/contact-crud']);
  }

  edit(id: any):void{
    this.router.navigate(['dashboard/contact-crud/',id]);
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/contacts/contact/contact.component.ts